<script lang="ts" setup>
import { throttle } from 'lodash-es'

export interface MLoadRef {
  check: () => void
}

const props = defineProps<{
  empty: boolean
  loadingText?: string
  emptyText?: string
  manal?: boolean
}>()
const loading = ref(false)
const emit = defineEmits<{
  (
    e: 'onScrollEnd',
    ev: {
      complete: () => void
    }
  ): void
}>()
const load = ref<HTMLElement>()
const _loadingText = props.loadingText || '加载中...'
const _emptyText = props.emptyText || '没有更多了'

onMounted(() => {
  if (!props.manal) {
    window.addEventListener('scroll', throttledHandler)
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', throttledHandler)
})

const throttledHandler = throttle(
  () => {
    if (loading.value) {
      return
    }
    check()
  },
  200,
  {
    leading: true,
    trailing: true
  }
)

function check() {
  const isEnd =
    load.value &&
    load.value.getBoundingClientRect().top < window.innerHeight &&
    !props.empty &&
    !loading.value
  if (isEnd) {
    emitScrollEnd()
  }
}

function emitScrollEnd() {
  loading.value = true
  const e = {
    complete: () => {
      loading.value = false
    }
  }
  emit('onScrollEnd', e)
}

function handleClick() {
  emitScrollEnd()
}

defineExpose({
  check
})
</script>

<template>
  <div ref="load" class="m-load">
    <span v-if="manal && !empty" class="manal" @click="handleClick">
      点击加载
    </span>
    <span v-else>{{ empty ? _emptyText : _loadingText }}</span>
  </div>
</template>

<style lang="scss" scoped>
.m-load {
  height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-gray-600);
  .manal {
    cursor: pointer;
    user-select: none;
    color: var(--color-primary);
    &:hover {
      color: var(--color-primary-600);
    }
  }
}
</style>
